import { z } from 'zod'
import { TenantPlan, TenantStatus, Currency } from '../types/enums'

export const CreateTenantSchema = z.object({
  name: z
    .string({ required_error: 'Firma adı zorunludur.' })
    .min(2, 'Firma adı en az 2 karakter olmalıdır.')
    .max(100, 'Firma adı en fazla 100 karakter olabilir.'),
  legalName: z
    .string({ required_error: 'Yasal unvan zorunludur.' })
    .min(2, 'Yasal unvan en az 2 karakter olmalıdır.')
    .max(150),
  subdomain: z
    .string({ required_error: 'Subdomain zorunludur.' })
    .min(3, 'Subdomain en az 3 karakter olmalıdır.')
    .max(50, 'Subdomain en fazla 50 karakter olabilir.')
    .regex(
      /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/,
      'Subdomain yalnızca küçük harf, rakam ve tire içerebilir.',
    ),
  plan: z.nativeEnum(TenantPlan, { required_error: 'Plan seçimi zorunludur.' }),
  defaultCurrency: z.nativeEnum(Currency).default(Currency.TRY),
  defaultTimezone: z.string().default('Europe/Istanbul'),
  contractStartDate: z.string().datetime({ offset: true }),
})

export const UpdateTenantSchema = z.object({
  name: z.string().min(2).max(100).optional(),
  legalName: z.string().min(2).max(150).optional(),
  plan: z.nativeEnum(TenantPlan).optional(),
  status: z.nativeEnum(TenantStatus).optional(),
  defaultCurrency: z.nativeEnum(Currency).optional(),
  defaultTimezone: z.string().optional(),
  subscriptionRefCode: z.string().max(100).nullable().optional(),
  subscriptionStatus: z.string().max(30).nullable().optional(),
  yearlyPriceOverride: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Geçerli bir fiyat girin').nullable().optional(),
  subscriptionStartDate: z.string().datetime({ offset: true }).nullable().optional(),
  subscriptionEndDate: z.string().datetime({ offset: true }).nullable().optional(),
  contractStartDate: z.string().datetime({ offset: true }).optional(),
})

/** Firma bilgileri (Ayarlar > Genel) — `PATCH /settings/tenant`. Boş string alanı temizler; gönderilmeyen alan değişmez. */
export const UpdateTenantInfoSchema = z.object({
  name: z.string().max(100),
  legalName: z.string().max(150),
  tradeName: z.string().max(250),
  sector: z.string().max(150),
  address: z.string().max(500),
  district: z.string().max(100),
  city: z.string().max(100),
  phone: z.string().max(30),
  fax: z.string().max(30),
  taxOffice: z.string().max(100),
  taxNumber: z.string().max(20),
  mersisNo: z.string().max(20),
  tradeRegistryNo: z.string().max(30),
  naceCodes: z.string().max(500),
  defaultCurrency: z.string().max(3),
  defaultTimezone: z.string().max(100),
}).partial()

export type CreateTenantInput = z.infer<typeof CreateTenantSchema>
export type UpdateTenantInput = z.infer<typeof UpdateTenantSchema>
